/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/travelInformation/flightScheduleSearch.js
*    TO   --> ./legacy-web/src/main/assets/js/travel-information/flight-schedule-search.js
**/

var AASandbox = AAcom('browserdetect', 'utilities', 'ajax', 'commonsetup', 'aaDatePicker', 'aaAutoComplete', 'airportLookup', 'nearestAirportLookup', function(AAUI) {
	$j(function(){
		AAUI.initAutoComplete(".aaAutoComplete");
		AAUI.initDatePicker(".aaDatePicker");
		$j("#departureDateStr").datepicker("setDate", new Date());
		AAUI.initAirportLookup(".aaAirportLookup");
		AAUI.initNearestAirportLookup(".current-location-btn");

		AAUI.onClick(".errorList a", function (event) {
			event.preventDefault();
			var $this = $j(this);
			var target = $this.attr('href');
			target = "flightScheduleSearchView." + target.substring(1, target.length);
			var $target = $j(document.getElementById(target));
			window.scrollTo(window.scrollX, $target.offset().top - 50);
			$target.focus();
		});

		$j("#departureDateFormat").val($j.datepicker._defaults.dateFormat);
	});
});
